import { useEffect, useState, useContext } from 'react';
import { useForm } from "react-hook-form";
import { Modal, Button } from 'react-bootstrap';
import * as Api from '../../../api/Api';
import { useQuery } from 'react-query';
import * as KeyNames from '../../../api/KeyNames';
import { ErrorConnection } from '../../../Components/Error/Error';
import { Loading } from '../../../Components/Loading/Loading';
import { FeedbackContext } from "../../../Components/Context/FeedbackContext";
import { useGetToken } from '../../../Hooks/CustomHooks';
import PermissionsGate from '../../../api/PermissionsGate';
import SelectPermision from './select_permission';
import { SCOPES} from '../../../config/permissions-map';



export default function AddRole({ showAddRole, setShowAddRole, setRefreshData }) {
    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);

    const [newRole, setNewRole] = useState(null);
    const [listPermissionSelect, setListPermissionSelect] = useState([]);

    const { register, handleSubmit, formState: { errors }, reset } = useForm();

    const onSubmit = dataNewRole => {
        setNewRole({
            ...dataNewRole,
            listPermissions: listPermissionSelect
        });
        setShowAddRole(false);
    };
    const token = useGetToken();
    //Llamada al servicio de ADDROLE. El key debe ser único y por eso se setea con el resetToken
    let { data, isLoading, isError, error } = useQuery([KeyNames.SessionRespuesta, newRole],
        async () => await Api.addRole(
            { newRole: newRole, token: token }
        ),
        {
            enabled: Boolean(newRole)
        });

    useEffect(() => {
        if (data) {
            if (data.success) {
                setFeedbackContext({ ...feedbackContext, showMessage: true, idMessage: 100 });
                reset(null);
                setNewRole(null);
                setRefreshData(true);
                setTimeout(window.location.reload(), 2000);
            } else {
                setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId });
            }
        }

    }, [data]);


    if (isLoading) return (<Loading />)
    if (isError) return (<ErrorConnection error={error/*.response.status*/} />)

    return (
        <PermissionsGate RenderError={() => <></>} scopes={[SCOPES.GESTION_USUARIOS]} >
            <Modal className='mw-750p' size="lg"  show={showAddRole} onHide={() => setShowAddRole(false)} animation={false} aria-labelledby="contained-modal-title-vcenter" scrollable={true}
                centered>
                <Modal.Header >
                    <Modal.Title>Agregar Rol</Modal.Title>
                </Modal.Header>
                <Modal.Body className=' mx-5 my-7'>
        
                    <form>
                        <div className="fv-row mb-7 ">

                            <label className="required fw-bold fs-6 mb-2">Nombre de rol</label>

                            <input type="text" {...register("name", { required: true })} className="form-control form-control-solid mb-3 mb-lg-0" placeholder="Nombre Completo" />
                            <>{errors.name && <span className="text-danger">Ingresar el rol</span>}</>
                        </div>

                    </form>
                    <SelectPermision listPermissionSelectDefault={listPermissionSelect} setListPermission={setListPermissionSelect}></SelectPermision>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secundary" onClick={() => setShowAddRole(false)}>Cancelar</Button>
                    <Button variant="primary" onClick={handleSubmit(onSubmit)}>Guardar</Button>
                </Modal.Footer>
            </Modal>
        </PermissionsGate>
    )
}
